import fullCalendarCoreStyles from '@fullcalendar/core/main.css';
import fullCalendarDayGridStyles from '@fullcalendar/daygrid/main.css';
import fullCalendarTimegridStyles from '@fullcalendar/timegrid/main.css';
import {FC} from 'react';

import {useCss} from '../../../../libs/shared/ui/src/css/cssContext';

export const FullCalendarStyles: FC = () => {
  useCss(fullCalendarCoreStyles);
  useCss(fullCalendarTimegridStyles);
  useCss(fullCalendarDayGridStyles);

  return null;
};
